export default __webpack_public_path__ + "static/bproperty-a8a3cb2d181e371e28eb6fa2bcf97b37.png";